module.exports = "<footer class=\"footer\">\n  <div class=\"footer-block buttons\">\n  </div>\n  <div class=\"footer-block author\">\n      @2021 NANNYTAX LLC. ALL RIGHTS RESERVED\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/footer/footer.component.html
// module id = 359
// module chunks = 1